'use strict';

DoohApps
.directive('showFile', [function () {
    return {
        restrict: 'EA',
        scope: {
            FilePath: '=filepath',
            FileName: '@filename',
            FileType: '@filetype',
            FileSize: '=filesize'
        },
        link: function (scope, elem) {
            scope.$watch(function () { return scope.FilePath }, function () {

                elem.empty();
                var type = scope.FileType.split('/')[0].toLowerCase();
                if (type == 'image' && scope.FilePath != '' && typeof scope.FilePath != 'undefined') {
                    elem.append('<img src="' + scope.FilePath + '"/>');
                } else if (typeof scope.FilePath != 'undefined') {
                    elem.append('<p class="margin-auto">No preview available</p>');
                    elem.children().last().append('<span class="previewName" title="" + scope.FileName + "">' + scope.FileName + '</span>');
                }

                if (Math.round(((scope.FileSize / 1024) / 1000) / 1000) > 2) {
                    elem.append('<p class="margin-auto" style="color:red">Maxmum size 2GB</p>');
                }
            }
        )
        }
    }
}]);